(() => {
  const fold = value => String(value || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
  const parseDate = value => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(value || '')) return null;
    const [year, month, day] = value.split('-').map(Number);
    const date = new Date(Date.UTC(year, month - 1, day, 12));
    return date.getUTCFullYear() === year && date.getUTCMonth() === month - 1 && date.getUTCDate() === day ? date : null;
  };
  function init(root) {
    if (root.dataset.mapUiReady === 'true') return;
    const library = window.NanaTastingLibrary;
    if (!library || Object.keys(library.recipes || {}).length !== 364) return;
    root.dataset.mapUiReady = 'true';
    const data = JSON.parse(root.querySelector('[data-nt-data]').textContent);
    const L = JSON.parse(root.querySelector('[data-nt-labels]').textContent);
    const q = selector => root.querySelector(selector);
    const search = q('[data-nt-search]'), weeks = q('[data-nt-week]'), grid = q('[data-nt-grid]');
    const prev = q('[data-nt-prev]'), next = q('[data-nt-next]'), status = q('[data-nt-status]');
    const dialog = q('[data-nt-dialog]'), detail = q('[data-nt-detail]'), startInput = q('[data-nt-start]');
    const official = root.dataset.start || library.meta.defaultStart;
    let start = parseDate(official) || parseDate(library.meta.defaultStart), mode = 'all', expandedAll = false, collapsedAll = false, geography = {}, favorites = new Set(), returnFocus = null;
    const store = (key, value) => { try { localStorage.setItem(key, value); return true; } catch { return false; } };
    try {
      const saved = JSON.parse(localStorage.getItem('nana-tasting-favorites-v1') || '[]');
      if (Array.isArray(saved)) favorites = new Set(saved.filter(day => Number.isInteger(day) && day >= 1 && day <= 364));
      const personalStart = parseDate(localStorage.getItem('nana-tasting-start-v1'));
      if (personalStart) start = personalStart;
    } catch {}
    const date = day => new Date(+start + (day - 1) * 86400000);
    const iso = day => date(day).toISOString().slice(0, 10);
    const fmt = (value, year = false) => new Intl.DateTimeFormat(document.documentElement.lang || 'en-US', {month:'short', day:'numeric', ...(year ? {year:'numeric'} : {}), timeZone:'UTC'}).format(value);
    function el(tag, cls, value) {
      const node = document.createElement(tag); node.className = cls;
      if (value !== undefined) node.textContent = value;
      return node;
    }
    function icon(type) {
      const ns='http://www.w3.org/2000/svg',svg=document.createElementNS(ns,'svg'),path=document.createElementNS(ns,'path');
      svg.setAttribute('viewBox','0 0 24 24');svg.setAttribute('aria-hidden','true');
      path.setAttribute('d',type==='heart'?'M12 20S3 14.5 3 8.5a4.5 4.5 0 0 1 9-1 4.5 4.5 0 0 1 9 1C21 14.5 12 20 12 20Z':'M6 18 18 6M6 6h12v12');svg.append(path);return svg;
    }
    function paintHeart(button, selected) {
      button.replaceChildren(icon('heart'));button.setAttribute('aria-pressed',String(selected));
    }
    function picture(row) {
      const wrap = el('div', 'nt-map'), art = library.maps[row.country];
      const img = el('img', '', undefined);
      img.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(art.svg); img.alt = ''; img.width = 320; img.height = 200; img.loading = 'lazy'; img.decoding = 'async';
      wrap.append(img, el('span', 'nt-map-number', L.day + ' ' + String(row.day).padStart(3, '0')));
      return wrap;
    }
    const publisherRating = source => source.rating ? `★ ${source.rating.value}/5 · ${source.rating.count} ${source.rating.unit === 'reviews' ? L.review_count : L.rating_count}` : L.unrated;
    const draftInfo = row => window.NanaWorldDrafts?.info(root,row.day);
    const displayTitle = row => draftInfo(row)?.displayTitle || window.NanaCookAlong?.[row.day]?.displayTitle || row.dish;
    function heart(row) {
      const button = el('button', 'nt-heart'); button.type = 'button'; button.dataset.favoriteDay = row.day;
      function update() {
        paintHeart(button, favorites.has(row.day));
        button.setAttribute('aria-label', (favorites.has(row.day) ? L.saved : L.save) + ': ' + displayTitle(row));
      }
      update();
      button.addEventListener('click', () => {
        favorites.has(row.day) ? favorites.delete(row.day) : favorites.add(row.day);
        const persisted = store('nana-tasting-favorites-v1', JSON.stringify([...favorites]));
        root.querySelectorAll(`[data-favorite-day="${row.day}"]`).forEach(node => {
          paintHeart(node, favorites.has(row.day));
          node.setAttribute('aria-label', (favorites.has(row.day) ? L.saved : L.save) + ': ' + displayTitle(row));
        });
        q('[data-nt-favorite-count]').textContent = favorites.size;
        if (!persisted) q('[data-nt-personal-note]').textContent = L.storage_unavailable;
        if (mode === 'favorites') render();
      });
      return button;
    }
    function sourceLink(source) {
      const link = el('a', 'nt-source-link', (source.methodVerified ? L.source : L.selected_source));link.append(icon('arrow'));
      link.href = source.url; link.target = '_blank'; link.rel = 'noopener noreferrer'; return link;
    }
    function open(row, trigger) {
      const original = library.recipes[row.day], draft = draftInfo(row);
      const source = draft?.url ? {...original,credit:draft.credit,url:draft.url,methodVerified:false} : original; returnFocus = trigger;
      detail.replaceChildren(); detail.append(picture(row));
      const body = el('div', 'nt-detail-body');
      body.append(el('p', 'nt-date', L.day + ' ' + row.day + ' · ' + fmt(date(row.day), true)));
      const title = el('h2', '', displayTitle(row)); title.id = 'NtDialogTitle-' + root.id.replace('NanaTasting-', '');
      body.append(title, el('p', 'nt-country', row.country + ' · ' + row.region));
      const credit = el('div', 'nt-credit');
      credit.append(el('p', '', L.by + ' ' + source.credit));
      if (row.day < 38) {
        credit.append(el('p', 'nt-detail-source-title', source.sourceTitle), el('p', 'nt-rating', publisherRating(source)));
        if (source.checked) credit.append(el('p', 'nt-checked', L.checked + ': ' + source.checked));
      }
      body.append(credit, el('p', '', row.day >= 38 ? L.draft_display_notice : source.intro));
      if (row.day < 38 && source.ingredientOverview?.length) {
        body.append(el('h3', '', L.ingredients));
        const overview = el('div', 'nt-ingredient-overview'); overview.append(el('p', '', source.ingredientOverview.join(' · '))); body.append(overview);
      }
      if (row.day < 38 && source.context) body.append(el('p', '', source.context));
      if (row.day < 38 && source.adaptation) body.append(el('h3', '', L.adaptation), el('p', 'nt-adaptation', source.adaptation));
      if (row.day < 38 && source.reviewNote) body.append(el('p', 'nt-source-status', source.reviewNote));
      const actions = el('div', 'nt-detail-actions'); actions.append(sourceLink(source), heart(row)); body.append(actions, el('p', 'nt-review-note', L.source_notice));
      detail.append(body); dialog.showModal(); q('[data-nt-close]').focus();
    }
    function render() {
      const query = fold(search.value.trim()), week = Number(weeks.value);
      let rows = mode === 'week' && !query && !geography.country && !geography.region ? data.slice(week * 7, week * 7 + 7) : data;
      if (mode === 'favorites') rows = rows.filter(row => favorites.has(row.day));
      if (geography.country) rows = rows.filter(row => row.country === geography.country);
      if (geography.region) rows = rows.filter(row => row.region === geography.region);
      if (query) rows = rows.filter(row => fold([row.country, row.region, row.dish, displayTitle(row), draftInfo(row)?.credit || library.recipes[row.day].credit].join(' ')).includes(query));
      const fragment = document.createDocumentFragment();
      const grouped = new Map();
      rows.forEach(row => {
        const number = Math.floor((row.day - 1) / 7);
        if (!grouped.has(number)) grouped.set(number, []);
        grouped.get(number).push(row);
      });
      for (const [number, weekRows] of grouped) {
        const group = el('details', 'nt-week-group'); group.open = expandedAll || (!collapsedAll && (mode !== 'all' || Boolean(query || geography.country) || number === Number(weeks.value)));
        const heading = el('summary', 'nt-week-heading');
        heading.append(el('span', 'nt-week-number', L.week_label + ' ' + (number + 1)), el('span', 'nt-week-range', fmt(date(number * 7 + 1)) + ' — ' + fmt(date(number * 7 + 7))), el('span', 'nt-week-day-range', L.day + ' ' + (number * 7 + 1) + '–' + (number * 7 + 7)));
        const days = el('div', 'nt-week-days');
        for (const row of weekRows) {
          const source = library.recipes[row.day], recipe = window.NanaCookAlong?.[row.day], draft = window.NanaWorldDrafts?.has(root,row.day) ? draftInfo(row) : null;
          const card = el('article', 'nt-card nt-compact-card'), disclosure = el('details', 'nt-compact'); card.dataset.ntRegion = row.region;
          const summary = el('summary', 'nt-compact-summary');
          summary.append(picture(row));
          const text = el('div', 'nt-compact-copy');
          const meta = el('div', 'nt-compact-meta');
          meta.append(el('span', 'nt-compact-day', L.day + ' ' + String(row.day).padStart(3, '0')), el('time', '', fmt(date(row.day))));
          text.append(meta, el('p', 'nt-country', row.country), el('h3', 'nt-dish', displayTitle(row)));
          summary.append(text, el('span', 'nt-disclosure-mark', '+'));
          const body = el('div', 'nt-body nt-compact-body');
          body.append(el('p', 'nt-source-mini', L.by + ' ' + (recipe?.credit || draft?.credit || source.credit)));
          body.append(el('p', 'nt-source-status', recipe ? L.cookalong_draft : draft ? L.cookalong_lazy_draft : L.review_pending));
          if (recipe?.yield || draft?.yield) body.append(el('p', 'nt-cook-yield', recipe?.yield || draft.yield));
          const actions = el('div', 'nt-card-actions'), button = el('button', 'nt-view', L.view);
          button.type = 'button'; button.setAttribute('aria-label', L.view + ': ' + displayTitle(row));
          button.addEventListener('click', () => open(row, button));
          actions.append(button, heart(row)); body.append(actions);
          disclosure.append(summary, body); card.append(disclosure); days.append(card);
        }
        group.append(heading, days); fragment.append(group);
      }
      if (!rows.length) fragment.append(el('p', 'nt-empty', mode === 'favorites' ? L.empty_favorites : L.empty));
      grid.replaceChildren(fragment);
      status.textContent = rows.length + ' ' + L.matches + (geography.country ? ' · ' + geography.country : geography.region ? ' · ' + geography.region : '');
      const weekMode = mode === 'week' && !query && !geography.country && !geography.region;
      prev.disabled = !weekMode || week === 0; next.disabled = !weekMode || week === 51; weeks.disabled = !weekMode;
      q('[data-nt-favorite-count]').textContent = favorites.size;
      root.querySelectorAll('[data-nt-mode]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.ntMode === mode)));
    }

    function updateCalendar(chooseCurrentWeek = false) {
      const previousWeek = weeks.value; weeks.replaceChildren();
      for (let week = 0; week < 52; week++) {
        const option = document.createElement('option'); option.value = week;
        option.textContent = `${L.week_label} ${week + 1} / ${fmt(date(week * 7 + 1))} — ${fmt(date(week * 7 + 7))}`; weeks.append(option);
      }
      const now = new Date(), parts = new Intl.DateTimeFormat('en-CA', {timeZone:'America/Chicago', year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(now);
      const get = type => parts.find(part => part.type === type).value;
      const today = parseDate(`${get('year')}-${get('month')}-${get('day')}`);
      weeks.value = chooseCurrentWeek ? Math.max(0, Math.min(51, Math.floor((today - start) / 604800000))) : (previousWeek || '0');
      startInput.value = iso(1); q('[data-nt-range]').textContent = fmt(date(1), true) + ' — ' + fmt(date(364), true); render();
    }
    root.addEventListener('nana:tasting-filter', event => { geography = {country:event.detail.country || '',region:event.detail.region || ''}; mode = 'all'; collapsedAll = false; render(); });
    root.addEventListener('nana:cookalong-ready', render);
    q('[data-nt-expand-weeks]').addEventListener('click', () => { expandedAll = !expandedAll; collapsedAll = !expandedAll; const button = q('[data-nt-expand-weeks]'); button.setAttribute('aria-pressed', String(expandedAll)); button.textContent = expandedAll ? L.collapse_weeks : L.expand_weeks; render(); });
    search.addEventListener('input', () => { collapsedAll = false; render(); }); weeks.addEventListener('change', () => { collapsedAll = false; render(); });
    prev.addEventListener('click', () => { weeks.value = Number(weeks.value) - 1; render(); });
    next.addEventListener('click', () => { weeks.value = Number(weeks.value) + 1; render(); });
    root.querySelectorAll('[data-nt-mode]').forEach(button => button.addEventListener('click', () => { mode = button.dataset.ntMode; collapsedAll = false; geography = {}; root.dispatchEvent(new CustomEvent('nana:tasting-reset')); render(); }));
    startInput.addEventListener('change', () => {
      const chosen = parseDate(startInput.value);
      if (!chosen) { startInput.setCustomValidity(L.invalid_date); startInput.reportValidity(); return; }
      startInput.setCustomValidity(''); start = chosen; store('nana-tasting-start-v1', iso(1)); updateCalendar();
    });
    q('[data-nt-reset-start]').addEventListener('click', () => { start = parseDate(official) || parseDate(library.meta.defaultStart); startInput.setCustomValidity(''); try { localStorage.removeItem('nana-tasting-start-v1'); } catch {} updateCalendar(); });
    q('[data-nt-close]').addEventListener('click', () => dialog.close());
    dialog.addEventListener('close', () => { if (returnFocus?.isConnected) returnFocus.focus(); });
    dialog.addEventListener('click', event => { if (event.target === dialog) { const bounds = dialog.getBoundingClientRect(); if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close(); } });
    updateCalendar(true);
  }
  function boot() { document.querySelectorAll('.nana-tasting').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, {once:true}); else boot();
  document.addEventListener('shopify:section:load', boot);
})();

